import ModalButton from '../ModalButton';
import { MODAL_EVENTS } from '../Modal';

export default class DynamicModalButton extends ModalButton {
  modalIdStack = [];
  groupId = this.getAttribute('data-group-id') || null;

  #handleModalOpened;
  #handleModalClosed;

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    this.#handleModalOpened = this.#onModalOpened.bind(this);
    this.#handleModalClosed = this.#onModalClosed.bind(this);

    document.addEventListener(MODAL_EVENTS.opened, this.#handleModalOpened);
    document.addEventListener(MODAL_EVENTS.closed, this.#handleModalClosed);

    this.extraData = { groupId: this.groupId };
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(MODAL_EVENTS.opened, this.#handleModalOpened);
    document.removeEventListener(MODAL_EVENTS.closed, this.#handleModalClosed);
  }

  #onModalOpened(event) {
    if (event.detail?.groupId !== this.groupId) return;
    this.modalIdStack.push(event.detail.id);
    this.setAttribute('data-modal-id', event.detail.id);
  }

  #onModalClosed(event) {
    if (event.detail?.groupId !== this.groupId) return;
    this.modalIdStack.pop();
    this.setAttribute('data-modal-id', this.modalIdStack[this.modalIdStack.length - 1] || '');
  }
}
